import { apiClient } from './client';

interface EvaluationLimitStatus {
  can_create: boolean;
  current_count: number;
  max_count: number | null;
  remaining: number | null;
}

export const evaluationApi = {
  // Check current evaluation creation limit status
  async getEvaluationLimitStatus(): Promise<EvaluationLimitStatus> {
    const response = await apiClient.get('/api/evaluation-limit-status');
    return response as EvaluationLimitStatus;
  }
};